import './modal.scss';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class Modal {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-modal',
            modalAttr: 'data-modaltarget',
            scrollerAttr: 'scroller',
            onAjaxLoaded: null,
            onClosed: null,
            loader: null
        };

        this.settings = Object.assign({}, defaults, options);
        this.$modal = element;
        this.modalOpen = false;
        this.$modalTarget = null;
        this.$modalScroller = null;
        this.$fullImageSrc = this.$modal.dataset.modalImageSrc;
        this.$fullImageAlt = this.$modal.dataset.modalImageAlt;

        const modalId = this.$modal.getAttribute('data-modal');

        if (modalId) {
            this.$modalTarget = document.getElementById(modalId);

            if (this.$fullImageSrc) {
                this.$fullsizeImage = this.$modalTarget.querySelector('[data-modal-image]');
            }
        }
    }

    initialize () {
        this.setEvents();
    }

    setEvents () {
        this.$modal.setAttribute('data-modal-init', 'true');

        this.$modal.addEventListener('click', (e) => {
            e.preventDefault();
            this.openModal();
        });

        if (this.$modal.getAttribute('data-modal-open') !== null) {
            window.setTimeout(() => {
                this.openModal();
            }, 500);
        }

        // open modal on enter or space key
        this.$modal.addEventListener('keydown', (e) => {
            if (e.code === 'Enter' || e.code === 'Space') {
                e.preventDefault();
                this.openModal();
            }
        });

        // close modal on ESC key
        document.addEventListener('keydown', (e) => {
            let isEscape = false;
            if ('key' in e) {
                isEscape = (e.key === 'Escape' || e.key === 'Esc');
            } else {
                isEscape = (e.keyCode === 27);
            }
            if (isEscape && this.modalOpen === true) {
                this.closeModal();
            }
        });
    }

    openModal () {
        this.$modal.setAttribute('aria-pressed', 'true');
        if (this.$modalTarget) {
            if (this.$fullsizeImage && this.$fullImageSrc) {
                this.setImageSource();
            }

            this.showModal();
        }
    }

    setImageSource () {
        this.$fullsizeImage.src = this.$fullImageSrc;

        if (this.$fullImageAlt) {
            this.$fullsizeImage.setAttribute('alt', this.$fullImageAlt);
        }
    }

    showModal () {
        this.$modalScroller = this.$modalTarget.querySelector('[' + this.settings.modalAttr + '="' + this.settings.scrollerAttr + '"]');
        this.$modalTarget.classList.add('is--active');
        this.$modalTarget.setAttribute('aria-hidden', 'false');

        this.$modalTarget.querySelector('[data-modal-close-btn]').addEventListener('keydown', (e) => {
            if (e.code === 'Enter' || e.code === 'Space') {
                e.preventDefault();
                this.closeModal();
            }
        });

        setTimeout(() => {
            this.$modalTarget.querySelector('[data-modal-close-btn]').focus();
        }, 100);

        if (this.$modalScroller) {
            disableBodyScroll(this.$modalScroller);
        }

        document.addEventListener('keydown', (event) => {
            if (event.code === 'Tab' || event.code === 'Tabs') {
                this.handleOutsideClick(event);
            }
        });

        const $$exists = this.$modalTarget.querySelectorAll('[data-modal-close]');
        $$exists.forEach(($exit) => {
            $exit.addEventListener('click', (e) => {
                e.preventDefault();
                this.closeModal();
            });
        });

        this.modalOpen = true;
        this.$modalTarget.API = this;
    }

    closeModal () {
        this.$modalTarget.classList.remove('is--active');

        setTimeout(() => {
            this.$modalTarget.setAttribute('aria-hidden', 'true');
        }, 100);

        if (this.$modalScroller) {
            enableBodyScroll(this.$modalScroller);
        }

        this.modalOpen = false;

        if (typeof this.settings.onClosed === 'function') {
            this.settings.onClosed(this.$modalTarget);
        }
        this.$modal.setAttribute('aria-pressed', 'false');

        const modelClosed = new CustomEvent('modal.closed', {
            view: window,
            bubbles: true,
            cancelable: false,
            detail: {
                $context: this.$modalTarget
            }
        });

        window.dispatchEvent(modelClosed);
    }

    handleOutsideClick (e) {
        if (!this.$modalTarget.contains(e.target)) {
            this.closeModal();
        }
    }
}

export { Modal };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$modal = $context.querySelectorAll('[data-modal]:not([data-modal-init="true"])');

        for (let i = 0; i < $$modal.length; i++) {
            const modal = new Modal($$modal[i]);
            modal.initialize();
        }
    }
});
